export default __webpack_public_path__ + "static/media/csv.f1d58516.svg";